import { render, staticRenderFns } from "./CountryFaqForm.vue?vue&type=template&id=99b4fabe&scoped=true&"
import script from "./CountryFaqForm.vue?vue&type=script&lang=js&"
export * from "./CountryFaqForm.vue?vue&type=script&lang=js&"
import style0 from "./CountryFaqForm.vue?vue&type=style&index=0&id=99b4fabe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b4fabe",
  null
  
)

export default component.exports